import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import { Location } from "../../../@types/location";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";
export const findLocations = createAsyncThunk(
  "massiveDocumentCreate/findLocations",
  async (searchText, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
      const locationList = state.massiveDocumentCreate.locations;
      let maxUpdate: number = 0;

      if (locationList.length > 0) {
        const orderedList = [...locationList].sort((a, b) => {
          if (a.updatedAt && b.updatedAt && a.updatedAt < b.updatedAt) {
            return -1;
          }
          if (a.updatedAt && b.updatedAt && a.updatedAt > b.updatedAt) {
            return 1;
          }
          return 0;
        });
        maxUpdate = orderedList[orderedList.length -1].updatedAt!;
      }

    try {
      const { data } = await axiosInstance.get(`${api.baseURL}location`, {
        params: {
          limit: 10000,
          sort: "name ASC",
          where: {
            updatedAt: {">": maxUpdate},
            sourceOrganization: state.userAuthentication.user?.sourceOrganization,
          },
        },
      });
      let newList = [...locationList];

        data.forEach((element: any) => {
          if(newList.find(el => el.id === element.id)) {
            let location = newList.find(el => el.id === element.id);
            const indexToUpdate = newList.indexOf(location!);
            newList.splice(indexToUpdate, 1);
            newList.push(element);
          } else {
            newList.push(element);
          }
        });

        return newList;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
